import * as Yup from 'yup';

// ponytail: separados del componente para que el test no arrastre axios/antd.
export const loginSchema = Yup.object().shape({
  email: Yup.string()
    .email('Ingresá un email válido')
    .required('El email no puede estar vacío'),
  password: Yup.string().required('La contraseña no puede estar vacía'),
});

export const recoverSchema = Yup.object().shape({
  email: Yup.string()
    .email('Ingresá un email válido')
    .required('El email no puede estar vacío'),
});

export const confirmSchema = Yup.object().shape({
  code: Yup.string().required('El código no puede estar vacío'),
  newPassword: Yup.string().required('La contraseña no puede estar vacía'),
  confirmPassword: Yup.string().test(
    'password-match',
    'Las contraseñas no coinciden',
    function match(value) {
      return this.parent.newPassword === value;
    },
  ),
});
